import { render } from "./fullGalleryImageModal.vue?vue&type=template&id=6122a4c0&scoped=true&ts=true"
import script from "./fullGalleryImageModal.vue?vue&type=script&lang=ts"
export * from "./fullGalleryImageModal.vue?vue&type=script&lang=ts"

import "./fullGalleryImageModal.vue?vue&type=style&index=0&id=6122a4c0&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6122a4c0"]])

export default __exports__